import { integrationId } from '../fixture-ids';

export const integrationLegacyAlternates = {};

export const integrationLegacyFixtures = {
  INTEGRATION_CREATED: {
    action: 'INTEGRATION_CREATED',
    debugData: { integrationId, integrationName: 'Google Analytics 4', starterkitId: 'sk-ga4-v1' },
  },
  // No starterkitVersion -- useUpdateIntegration.js never supplied it. Do not add it.
  INTEGRATION_UPDATED: {
    action: 'INTEGRATION_UPDATED',
    debugData: { integrationId, integrationName: 'Google Analytics 4' },
  },
  INTEGRATION_DELETED: {
    action: 'INTEGRATION_DELETED',
    debugData: { integrationId, integrationName: 'Google Analytics 4' },
  },
};
